"use client";

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { initializeApplicationInsights } from "@/integrations/applicationInsights";

/**
 * Application Insights Provider for React
 * Wraps the application with Application Insights telemetry tracking
 */
export function ApplicationInsightsProvider({ children }) {
  const [aiContext, setAiContext] = useState(null);

  useEffect(() => {
    const { reactPlugin, appInsights } = initializeApplicationInsights();

    if (reactPlugin && appInsights) {
      queueMicrotask(() => setAiContext({ reactPlugin, appInsights }));
    }
  }, []);

  if (!aiContext?.reactPlugin) {
    return children;
  }

  return (
    <AppInsightsContext.Provider value={aiContext.reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
}

ApplicationInsightsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

